import { RouterProvider } from 'react-router-dom';
import { useAuthentication } from '@/context/AuthenticationProvider';
import ClientProvider from '@/context/ClientProvider';
import Login from '@/pages/Login';
import { router } from '@/router';

/**
 * The auth gate. The router only mounts once there is a session, so no screen has to defend against
 * an absent token.
 */
const App = () => {
  const { email } = useAuthentication();

  if (!email) {
    return <Login />;
  }

  return (
    <ClientProvider>
      <RouterProvider router={router} />
    </ClientProvider>
  );
};

export default App;
